export default class ImageService {
	constructor(thumbnailSizes) {
		this._thumbnailSizes = thumbnailSizes;
	}

	thumbnailSizes() {
		return this._thumbnailSizes;
	}
}
